var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "id": 'swatchesWrapper-' + _vm.$props.groupName,
      "customClass": ['swatches-view-swatches-wrapper-container-scroll-content organism', 'swatches-' + _vm.$props.groupName + '-container', {
        swatchesContainerActive: _vm.$props.activeGroup == _vm.$props.groupName
      }],
      "customStyle": _vm.$props.customStyle
    }
  }, [_c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$props.hasTitleProperties,
      expression: "$props.hasTitleProperties"
    }],
    staticClass: "swatches-view-swatches-wrapper-container-scroll-content is-group-title"
  }, [_c('CustomContainer', {
    staticClass: "group-title"
  }, [_c('CustomText', {
    staticClass: "group-text title",
    attrs: {
      "elementType": "span"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$props.hasTitle) + "\n      ")]), _c('CustomText', {
    staticClass: "group-text subtitle",
    attrs: {
      "elementType": "span"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$props.hasSubTitle) + "\n      ")])], 1)], 1), _vm._l(_vm.swatchesToRenderOrdered, function (subgroup, index) {
    return _c('CustomContainer', {
      key: subgroup.palette_id || subgroup.name,
      staticClass: "swatches-view-swatches-wrapper__swatches-container"
    }, [_c('SwatchSubGroup', {
      attrs: {
        "groupName": _vm.groupName,
        "subgroup": subgroup,
        "customsClasses": ['swatches-view-swatches-wrapper-swatches', subgroup.name + '-container', {
          center: false,
          'swatches-view-swatches-wrapper-swatches--first-subgroup': index === 0
        }]
      }
    })], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }